//  导入 axios
import axios from "axios";
import { shuaxin, xx } from "../api/index";
// 按需导入弹框的组件
import { Message, Loading } from "element-ui";
// 导入 vuex 的 store 模块
import store from "@/store";
import router from "@/router";
import apiConfig from "@/api/config";
import {
  clearCryptoSession,
  decryptBusinessResponse,
  encryptBusinessRequest,
  getCryptoSession,
  getRequestTarget,
  isBusinessCryptoEndpoint,
  releaseCryptoSession,
  retainCryptoSession,
  setCryptoRequestHeaders,
} from "@/utils/businessCrypto";

// 调用 axios.create()
const request = axios.create({
  //   baseURL: "http://218.249.73.244:58080",
  //  baseURL: "http://192.168.1.126:58080",
  //   baseURL: "http://192.168.11.25:58080",
  //   baseURL: "http://192.168.11.25:58080",

  //    baseURL: "http://218.249.73.246:58080",

  //  baseURL: "https://irshare.cn",
  baseURL: apiConfig.api,

  // 请求本地json文件，那么baseURL取空字符串，域名就会是项目域名
  timeout: 60000,
});

const releaseBusinessCryptoRequest = (config) => {
  if (!config || !config.__businessCryptoSessionRetained) {
    return;
  }
  releaseCryptoSession(config.__businessCrypto && config.__businessCrypto.session);
  config.__businessCryptoSessionRetained = false;
};

// 添加请求拦截器
request.interceptors.request.use(
  async function (config) {
    // 在发送请求之前做些什么
    //获得token
    // let token = sessionStorage.getItem("token");
    // //有设置就放行
    // ////console.log(token);
    // if (token) {
    //   config.headers["Authorization"] = "bearer " + JSON.parse(token);
    // }
    const id = localStorage.getItem("REFRESH_TOKEN");
    const to = sessionStorage.getItem("token");
    if (id == null && to !== null) {
      sessionStorage.removeItem("token");

      alert("您已在其它页面退出登录！");
      router.replace("/");
      window.location.reload();

      // setTimeout(() => {

      // }, 1000);
    }
    const method = (config.method || "get").toUpperCase();
    const requestTarget = getRequestTarget(config, request);
    if (isBusinessCryptoEndpoint(method, requestTarget)) {
      if (!config.__businessCryptoOriginalDataSet) {
        config.__businessCryptoOriginalData = config.data;
        config.__businessCryptoOriginalDataSet = true;
      } else {
        config.data = config.__businessCryptoOriginalData;
      }

      const session = await getCryptoSession();
      const randomBytes = window.crypto.getRandomValues(new Uint8Array(16));
      const requestId = Array.from(randomBytes)
        .map((value) => value.toString(16).padStart(2, "0"))
        .join("");
      config.headers = config.headers || {};
      setCryptoRequestHeaders(config.headers, session, requestId);
      config.__businessCrypto = { method, requestTarget, requestId, session };
      retainCryptoSession(session);
      config.__businessCryptoSessionRetained = true;

      try {
        if (method !== "GET") {
          config.data = await encryptBusinessRequest(
            session,
            method,
            requestTarget,
            requestId,
            config.data
          );
          config.headers["Content-Type"] = "application/json";
        }
      } catch (error) {
        releaseBusinessCryptoRequest(config);
        throw error;
      }
    }
    return config;
  },
  function (error) {
    // 对请求错误做些什么
    return Promise.reject(error);
  }
);
// 变量isRefreshing
let isRefreshing = false;
// 后续的请求队列
let requestList = [];
// 添加响应拦截器
request.interceptors.response.use(
  async function (response) {
    // 对响应数据做点什么
    if (response.config && response.config.__businessCrypto) {
      try {
        response.data = await decryptBusinessResponse(
          response.data,
          response.config.__businessCrypto
        );
      } finally {
        releaseBusinessCryptoRequest(response.config);
      }
    }
    let res = response.data;
    // 为了演示，这里仅展示处理状态码为401的情况

    if (res.code == "401") {
      // 控制是否在刷新token的状态
      if (!isRefreshing) {
        // 修改isRefreshing状态
        isRefreshing = true;

        // ////console.log(sessionStorage.getItem("retoken"));
        let token = sessionStorage.getItem("retoken");
        let so = JSON.parse(token);
        // //console.log(so);

        let datas = {
          //client_id: "cactus-web",
          // client_secret: "cactusli@proton",
          // grant_type: "refresh_token",
          refreshToken: so,
        };

        // 这里是获取新token的接口，方法在这里省略了。
        // //console.log(datas);
        const result = await shuaxin(datas);

        // 获取成功
        if (result && result.data) {
          //console.log(result.data, "23145678978954612");
          if (result.data.data == null) {
            // location.reload();
            alert("用户认证已过期请重新登录！");
            // 清除token
            sessionStorage.removeItem("token");
            // 重置状态
            isRefreshing = false;
            // 跳转到登录页
            router.replace("/denglu");
            return;
          }

          sessionStorage.removeItem("tokens");
          // 新token

          let newToken = result.data.data;
          // let a = await xx();
          // ////console.log(a);
          // 保存新的accessToken

          sessionStorage.setItem("token", JSON.stringify(newToken));
          // location.reload();
          // localStorage.setItem("retoken", newToken.refresh_token);

          // 替换新accessToken
          // response.config.headers.token = newToken;

          // token 刷新后将数组里的请求队列方法重新执行
          requestList.forEach((cb) => cb(newToken));
          // 重新请求完清空
          requestList = [];

          // 继续未完成的请求
          const resp = await request(response.config);
          // 重置状态
          isRefreshing = false;
          // 返回请求结果
          return resp;
        } else {
          // // 清除token
          // localStorage.clear();
          // // 重置状态
          // isRefreshing = false;
          // // 跳转到登录页
          // router.replace("/denglu");
          alert("用户认证已过期请重新登录！");
          // 清除token
          sessionStorage.removeItem("token");
          // sessionStorage.removeItem("retoken");
          // 重置状态
          isRefreshing = false;
          // 跳转到登录页
          router.replace("/denglu");
        }
      } else {
        // 后面的请求走这里排队
        // 返回未执行 resolve 的 Promise
        return new Promise((resolve) => {
          // 用函数形式将 resolve 存入，等待获取新token后再执行
          requestList.push((newToken) => {
            response.config.headers.token = newToken;
            resolve(request(response.config));
          });
        });
      }
    }

    if (response.status === 200) {
      return Promise.resolve(response);
    } else {
      Message.error(response.data.message("请求失败"));
      // 把这次 axios 请求标记为失败
      return Promise.reject(new Error(response.data.message("请求失败")));
    }
  },
  function (error) {
    // 对响应错误做点什么

    const failedConfig = error.config || (error.response && error.response.config);
    releaseBusinessCryptoRequest(failedConfig);
    if (
      error.response &&
      error.response.status === 401 &&
      error.response.data &&
      error.response.data.code === "CRYPTO_SESSION_EXPIRED" &&
      failedConfig &&
      failedConfig.__businessCrypto &&
      !failedConfig.__businessCryptoRetried
    ) {
      clearCryptoSession(failedConfig.__businessCrypto.session);
      failedConfig.__businessCryptoRetried = true;
      return request(failedConfig);
    }

    // 这里最好加上条件判断，防止属性的值不存在
    if (error.response && error.response.status) {
      Message.error("请求失败");
    }
    return Promise.reject(error);
  }
);
// 添加响应拦截器
// request.interceptors.response.use(
//   async function (response) {
//     // 对响应数据做点什么（如果需要）
//     // ...

//     // 假设response.data.code是我们检查的状态码
//     if (response.data.code == "401") {
//       // 注意这里通常是401，但根据你的代码，我假设是400
//       // 控制是否在刷新token的状态
//       // let a = sessionStorage.getItem("retoken");
//       // ////console.log(a);
//       // if (a !== null) {
//       //   return;
//       // }
//       if (!isRefreshing) {
//         // 修改isRefreshing状态
//         isRefreshing = true;

//         try {
//           let token = sessionStorage.getItem("retoken");
//           // 假设 shuaxin 是获取新 token 的函数
//           const result = await shuaxin(JSON.parse(token));
//           ////console.log(result);
//           // 获取成功
//           if (result && result.data) {
//             // 新token
//             let newToken = result.data;
//             // 保存新的accessToken和refreshToken
//             localStorage.setItem("token", newToken);
//             localStorage.setItem("retoken", newToken.refresh_token);

//             // token 刷新后将数组里的请求队列方法重新执行
//             requestList.forEach((cb) => cb(newToken));
//             // 重新请求完清空
//             requestList = [];

//             // 如果需要，继续未完成的请求（通常不需要，因为拦截器已经处理了）
//             // ...

//             // 重置状态
//             isRefreshing = false;

//             // 返回请求结果（如果需要继续未完成的请求，这里应该返回一个新的请求）
//             return response; // 或者其他你希望返回的内容
//           }
//         } catch (error) {
//           // 获取新 token 失败的处理
//           console.error("Failed to refresh token", error);

//           // 清除token，重置状态，并跳转到登录页
//           sessionStorage.removeItem("token");
//           sessionStorage.removeItem("retoken");
//           isRefreshing = false;
//           router.replace("/denglu");

//           // 返回一个 rejected Promise 表示请求失败
//           return Promise.reject(error);
//         }

//         // 如果 isRefreshing 仍为 true（即上面的代码没有抛出异常），则执行以下代码块
//       } else {
//         // 后面的请求走这里排队
//         return new Promise((resolve) => {
//           requestList.push((newToken) => {
//             // 使用新的 token 发起请求（这通常不会在这里发生，而是在外部调用时）
//             // ...
//             // 但为了演示，我们假设它在这里发生
//             resolve(response); // 或者其他你希望返回的内容
//           });
//         });
//       }
//     }

//     // 如果不是 400 错误，并且状态码为 200，则直接返回 response
//     if (response.status === 200) {
//       return response;
//     } else {
//       // 展示错误信息并返回 rejected Promise
//       Message.error(response.data.message || "请求失败"); // 假设 message 在 data 中
//       return Promise.reject(new Error(response.data.message || "请求失败"));
//     }
//   },
//   function (error) {
//     // 对响应错误做点什么
//     if (error.response && error.response.status) {
//       Message.error("请求失败"); // 或者显示更具体的错误信息，如 error.response.data.message
//     }
//     return Promise.reject(error);
//   }
// );

// 生成的 axios 实例，导出
export default request;
